import { BaseMetaTable, BaseUUID, NamingConvention } from "namirasoft-core";
import { NSBaseMetaTable_Frontend } from "./NSBaseMetaTable_Frontend";
import { NSBaseMetaDatabase } from "./NSBaseMetaDatabase";
import { NSBaseMetaTable_Backend } from "./NSBaseMetaTable_Backend";
import { NSBaseServer } from "./NSBaseServer";

export abstract class NSBaseMetaTable<Server extends NSBaseServer, Row> extends BaseMetaTable
{
    private static cft_tables = ["category", "field", "tag"];
    static getTableAndCFTsIfExists(naming: NamingConvention, tables: string[], name: string): string[]
    {
        name = NamingConvention.auto.convert(name, naming);
        tables = tables.map(t => NamingConvention.auto.convert(t, naming));
        return NSBaseMetaTable.getTableAndCFTs(naming, name).filter(t => tables.includes(t));
    }
    static getTableAndCFTs(naming: NamingConvention, name: string): string[]
    {
        name = NamingConvention.auto.convert(name, naming);
        return [name, ...NSBaseMetaTable.getCFTTables(naming, name)];
    }
    static getCFTTablesIfExists(naming: NamingConvention, tables: string[], name: string): string[]
    {
        name = NamingConvention.auto.convert(name, naming);
        tables = tables.map(t => NamingConvention.auto.convert(t, naming));
        return NSBaseMetaTable.getCFTTables(naming, name).filter(t => tables.includes(t));
    }
    static getCFTTables(naming: NamingConvention, name: string): string[]
    {
        name = NamingConvention.auto.convert(name, naming);
        let tables = NSBaseMetaTable.cft_tables.map(cft => name + "_" + cft);
        return tables.map(t => NamingConvention.auto.convert(t, naming));
    }
    static HasCFTTable(naming: NamingConvention, tables: string[], name: string): boolean
    {
        name = NamingConvention.auto.convert(name, naming);
        tables = tables.map(t => NamingConvention.auto.convert(t, naming))
        return NSBaseMetaTable.getCFTTables(naming, name).some(t => tables.includes(t));
    }
    static IsCFTTable(naming: NamingConvention, name: string): boolean
    {
        name = NamingConvention.auto.convert(name, naming);
        for (let i = 0; i < NSBaseMetaTable.cft_tables.length; i++)
        {
            let table = NSBaseMetaTable.cft_tables[i];
            table = NamingConvention.auto.convert(table, naming);
            if (name !== table)
                if (name.endsWith("_" + table))
                    return true;
        }
        return false;
    }

    override database: NSBaseMetaDatabase<Server>;
    public uuid: BaseUUID;
    public front_end: NSBaseMetaTable_Frontend;
    public back_end: NSBaseMetaTable_Backend<Row>;
    constructor(database: NSBaseMetaDatabase<Server>, name: string, text: string, uuid: BaseUUID)
    {
        super(database, name, text);
        this.database = database;
        this.uuid = uuid;
        this.front_end = new NSBaseMetaTable_Frontend(this, name);
        this.back_end = new NSBaseMetaTable_Backend<Row>();
    }
    isCFTTable(): boolean
    {
        return NSBaseMetaTable.IsCFTTable(NamingConvention.lower_case_dash, this.name);
    }
    hasFieldTables(): boolean
    {
        if (this.database)
            return NSBaseMetaTable.HasCFTTable(NamingConvention.lower_case_dash, Object.keys(this.database.tables), this.name);
        return false;
    }
};